import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";

function RedirectIfAuthenticated({ children }) {
  const token = sessionStorage.getItem("token");
  const role = sessionStorage.getItem("role");

  if (token && role) {
    if (role === "ADMIN") return <Navigate to="/dashboard" />;
    if (role === "USER") return <Navigate to="/ecommerce/dashboard" />;
  }

  return children;
}

RedirectIfAuthenticated.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RedirectIfAuthenticated;
